import type { DxReportViewer } from 'devexpress-reporting/dx-webdocumentviewer';
import React from 'react';
import { IReportViewerProps } from '../entities';

const ReportViewer: React.FC<IReportViewerProps> = props => {
	const ref = React.useRef();

	React.useEffect(() => {
		const loadCondition =
			props.reportId &&
			props.reportName &&
			props.projectName &&
			props.parametersKey &&
			!props.preview;

		let viewer: DxReportViewer;

		if (ref.current) {
			if (loadCondition) {
				(async () => {
					const analyticsUtils = await import(
						'@devexpress/analytics-core/analytics-utils'
					);
					const webDocumentViewer = await import(
						'devexpress-reporting/dx-webdocumentviewer'
					);
					const ko = await import('knockout');

					const requestOptions = {
						host: `${props.serviceUrl || ''}/`,
						invokeAction: 'ReportViewer'
					};

					analyticsUtils.ajaxSetup.ajaxSettings = {
						headers: props.ajaxHeaders,
						async: true
					};

					const reportUrl = ko.observable(
						`parametersKey=${encodeURIComponent(props.parametersKey)}&reportName=${
							props.reportName
						}&projectName=${props.projectName}`
					);

					viewer = new webDocumentViewer.DxReportViewer(ref.current, {
						requestOptions,
						reportUrl
					});

					viewer.render();
				})();
			} else if (props.preview) {
				(async () => {
					const webDocumentViewer = await import(
						'devexpress-reporting/dx-webdocumentviewer'
					);
					const ko = await import('knockout');

					const requestOptions = {
						host: `${props.serviceUrl || ''}/`,
						invokeAction: 'ReportViewer'
					};

					const reportUrl = ko.observable(`parametersKey=&reportName=&projectName=`);

					viewer = new webDocumentViewer.DxReportViewer(ref.current, {
						requestOptions,
						reportUrl
					});

					viewer.render();
				})();
			}
		}

		return () => {
			if (viewer) {
				viewer.dispose();
			}
		};
	}, [
		props.reportId,
		props.reportName,
		props.projectName,
		props.parametersKey,
		props.preview,
		ref.current
	]);

	return <div ref={ref} />;
};

export default ReportViewer;
